import { baseApi } from 'components/constants/Constants';
import { request } from '../api';
import { ContactRequest, RequestTypes } from 'types/ContactRequests';
import { useAxiosWithAuth } from './useAxios';
import { SegmentTag } from 'types/global';
import { ErrorHandler, SuccessHandler } from 'api/apiTS';
import { QuantityUnitType } from 'api/types/ReferenceDataTS';
export const createGenericContactRequest = (
  body: Partial<ContactRequest>,
  success: Function,
  error: Function
) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/contacts/request`,
    data: body
  };
  request(options, success, error);
};

export const createBrandPortalContactRequest = (
  body: Partial<ContactRequest>,
  success: Function,
  portalKey: string,
  error: Function
) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/portals/${portalKey}/contacts`,
    data: body
  };
  request(options, success, error);
};

export const createSupplierPortalContactRequestV2 = (
  body: Partial<ContactRequest>,
  eventKey: string,
  success: SuccessHandler,
  error: ErrorHandler
) => {
  const options = {
    method: 'POST',
    url: `${baseApi}/portals/${eventKey}/v2/requests`,
    data: body
  };

  request(options, success, error);
};

export const useCreateSampleCartRequest = (eventKey: string) =>
  useAxiosWithAuth(
    {
      url: `${baseApi}/portals/${eventKey}/v2/requests`,
      method: 'POST'
    },
    { manual: true }
  );

interface ShippingAddress {
  company: string;
  person_of_contact: string;
  city: string;
  country: string;
  postal_code: string;
  street: string;
  street_additional?: string;
  country_code: string;
  phone_number: string;
}

interface RequestItem {
  product_id: {
    company: string;
    segment: SegmentTag;
    product: string;
  };
  quantity_required: number;
  estimate_usage?: number;
  needed_by?: string;
  quantity_required_units: QuantityUnitType;
  estimated_usage_units?: QuantityUnitType;
}

export interface SampleCartPayload {
  type: RequestTypes.SAMPLE;
  shipping_address: ShippingAddress;
  message?: string;
  requests: RequestItem[];
}
